import { ErrorHandler, Injectable } from '@angular/core';
import { SpaContext } from './Classes/spacontext';
import { SpaLogger } from './Common/Classes/Global/spalogger.class';

@Injectable()
export class ErrHandler implements ErrorHandler {
	constructor(public _spaContext: SpaContext, private _spaLogger: SpaLogger) {}

	handleError(error) {
		console.error(error);
		if (typeof error !== 'undefined' && error !== null) {
			this._spaLogger.log(
				'Debug',
				['Public', 'ConsoleError'],
				`${error.name}: ${error['message']}`,
				{
					Url: window.location.href,
					LicensHolderId: this._spaContext.unitConfig.LicenceHolder.Id,
					UnitId: this._spaContext.unitConfig.Unit.UnitId,
					ErrorType: error.name,
				},
				error.stack,
			);
		}

		throw error;
	}
}
